var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.brochureCount
    ? _c("section", { staticClass: "full-width brochure-sticky" }, [
        _c("div", { staticClass: "container-fluid" }, [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              {
                staticClass: "col brochure-req-spacer",
                class: {
                  "brochure-stickyTs": _vm.brandName === _vm.Brand.Travelsphere,
                },
              },
              [
                _c("span", { class: { disabled: !_vm.brochureCount } }, [
                  _vm._v(_vm._s(_vm.brochureCount) + " brochure(s) selected"),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn",
                    attrs: {
                      disabled: !_vm.brochureCount,
                      "aria-label": "Request brochure",
                      title: "Click to request a brochure",
                    },
                    on: { click: _vm.changeState },
                  },
                  [_vm._v("Request Brochure(s)")]
                ),
              ]
            ),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }